module.exports = __webpack_public_path__ + "img/color-2.6499faa.png";